angular
  .module('contrast.services.organization', [])
  .factory('OrganizationService', function () {
    return {
      buildOrganization: function (organization) {
        var org = {}
        org.name = organization.name
        org.timezone = organization.timezone
        org.date_format = organization.date_format
        org.time_format = organization.time_format
        org.protection_enabled = organization.protection_enabled
        org.organization_uuid = organization.organization_uuid
        org.creation_time = organization.creation_time
        org.ossLicense = organization.ossLicense
        org.oss_license_nearing_expiration =
          organization.oss_license_nearing_expiration

        return org
      }
    }
  })
